export default __webpack_public_path__ + "static/media/hailscale_logo_white.7d9a9776.svg";